const PLBPostedBy = {
  ACCOUNT: "account",
  DEALER_OPERATOR: "dealer-operator",
  SEAOIL: "seaoil",
};

export default PLBPostedBy;
